// Обучение новичков (BackEnd/docs/TUTORIAL_PLAN.md).
// Состояние живёт на СЕРВЕРЕ (`GET /tutorial`): игрок ходит с телефона и с компьютера, а на одном
// устройстве меняются аккаунты — localStorage это не переживает (на этом уже ловили баг с заданиями).
// Тексты подсказок серверу не нужны: он шлёт код шага, экран рисует его через $t('tut.<код>').
import axios from 'axios';

const state = {
  data: null,
  loading: false,
  // 🔴 ЭКРАН, НА КОТОРОМ ИГРОК СЕЙЧАС (модель «что пройдено», решение оунера 2026-08-20). Сервер шлёт
  // не один шаг, а список доступных шагов ПО КАЖДОМУ ЭКРАНУ; какой из них показывать, решает роут.
  // Обновляется роутером на каждом переходе (`SET_TUT_ROUTE`).
  route: null,
  // Шаги, которые ЭКРАН отложил: условия для них сейчас нет (некого лечить, пустой сундук). Живут
  // только в памяти вкладки и НЕ уходят на сервер: шаг не пройден, он просто ждёт своего момента,
  // а игрок тем временем видит следующий доступный шаг этого же экрана (решение оунера).
  notNow: [],
  // 🔴 РАЗОВЫЕ ОБЗОРЫ, ЗАКРЫТЫЕ В ЭТОЙ ВКЛАДКЕ (жалоба оунера 2026-08-30: «обучение в магазине
  // запускается три раза подряд»). Обзор гаснет только когда сервер уберёт код из `tours`, а это
  // ответ на `POST /tutorial/seen` — до него экран, сбросивший счётчик остановок, показывал обзор
  // ЗАНОВО с первой остановки. Плюс сюда же приходил старый ответ `GET /tutorial`, выпущенный
  // раньше отметки, и воскрешал обзор. Локальная отметка ставится СРАЗУ и не зависит ни от сети,
  // ни от порядка ответов: «в этой вкладке уже показали» — знание клиента, «показывать ли при
  // следующем заходе» — решение сервера.
  toursSeen: [],
  // последний ролл награды за шаг ({items, index}) — окно рулетки показывает его и само гасит
  roll: null,
  // 🔴 ОКНА ОБУЧЕНИЯ СТРОГО ПОСЛЕДОВАТЕЛЬНЫ (требование оунера, повторялось трижды).
  // Флаг поднимается В МОМЕНТ отправки «шаг сделан» и держится, пока не закрыто окно награды:
  // между ответом сервера и открытием ролла экран успевал нарисовать СЛЕДУЮЩУЮ подсказку — она
  // мигала, гасла под окном награды и появлялась снова. Пока флаг поднят, подсказок нет вообще.
  rollPending: false,
  // ПОМОЩЬ ПО ПУНКТУ «Пути новичка» (решение оунера 2026-07-30): игрок нажал на пункт чек-листа —
  // его уводит в нужный раздел, и там наставник объясняет, как этот пункт закрыть. Держим код пункта.
  helpCode: null,
  // Сколько окон-подсказок ШАГОВ открыто прямо сейчас (регистрирует сам TutorialSpotlight).
  // Нужно, чтобы поверх подсказки шага не всплыла ВТОРАЯ карточка наставника — помощь по пункту
  // «Пути новичка» (оунер ловил дубль диалогов на колесе).
  spotCount: 0,
};

// Обучение пройдено ЦЕЛИКОМ. Старый бэк поля `all_done` не шлёт (выкат идёт одной командой, но
// вкладка игрока может пережить пересборку) — тогда читаем прежний смысл `finished`.
function allDone(data) {
  return data.all_done === undefined ? !!data.finished : !!data.all_done;
}

// Первый круг обучения когда-либо пройден. `finished` снимается кнопкой «Пройти заново», а отметка
// закрытого акта `act2` — нет: именно она и отличает выпускника от новичка.
function graduated(data) {
  return !!data.finished || (data.done || []).includes('act2');
}

// Доступные шаги ЭКРАНА (в порядке цепочки), без отложенных этим экраном.
function screenSteps(state, route) {
  const screens = (state.data && state.data.screens) || null;
  if (!screens) return [];
  const list = screens[route || state.route] || [];
  return list.filter((code) => !state.notNow.includes(code));
}

const getters = {
  // 🔴 Шаг, который показывает ТЕКУЩИЙ ЭКРАН (модель «что пройдено», 2026-08-20). Раньше это был
  // единственный глобальный указатель, и экран, куда игрок ушёл, не показывал ничего, пока клиент
  // не промотает чужие шаги. Теперь у каждого экрана свой курсор, а перепрыгнутое ждёт возвращения.
  // Старый сервер (вкладка пережила выкат) поля `screens` не шлёт — тогда прежнее поведение.
  tutorialStep: (state) => {
    if (!state.data) return null;
    if (!state.data.screens) return state.data.step;
    return screenSteps(state)[0] || null;
  },
  // Головной шаг цепочки — для «Справки», счётчика прогресса и воронки (НЕ для показа подсказок).
  tutorialHeadStep: (state) => (state.data ? state.data.step : null),
  // Доступные шаги произвольного экрана: нужен экранам, которые рисуют подсказку до перехода роута.
  tutorialScreenSteps: (state) => (route) => screenSteps(state, route),
  // 🔴 ШАГ ЕЩЁ ЖДЁТ ИГРОКА (доступен ХОТЬ ГДЕ, не обязательно на текущем экране). Нужен подсказкам,
  // которые рисует НЕ экран-хозяин шага: лобби PvP подсвечивает кнопку «Настройки фигур» на шаге
  // `daily_after`, хотя сам шаг живёт на `/daily`. Через `tutorialStep` такое не выразить — он
  // отдаёт шаг ТЕКУЩЕГО экрана, и на `/pvp` вернул бы null (подсветка молча пропала бы).
  tutorialPending: (state) => (code) => {
    if (!state.data || !code) return false;
    if (!state.data.screens) return state.data.step === code;   // старый сервер — прежнее поведение
    return Object.values(state.data.screens).some((list) => (list || []).includes(code));
  },
  // Шаг ОТЛОЖЕН этим экраном (`TUT_NOT_NOW`) — то есть он не пройден, но сейчас показывать нечего.
  // Нужен экрану, чтобы ВЕРНУТЬ шаг, когда условие наконец появилось (см. `TUT_AGAIN`).
  tutorialDeferred: (state) => (code) => !!code && state.notNow.includes(code),
  // Обучение ИДЁТ: не пройдено целиком, не пропущено и текущий акт НЕ ждёт события.
  // 🔴 `finished` тут больше не годится: он означает лишь «первый круг пройден» (Акт 2), а
  // Акты 3-4 приходят позже отдельными визитами наставника — они идут уже поверх «Справки».
  tutorialActive: (state) => !!state.data
    && !state.data.skipped && !allDone(state.data) && !state.data.gated,
  // Кнопка в меню: «Обучение» (идёт) / «Продолжить обучение» (пропущено) / «Справка» (пройдено).
  tutorialButton: (state) => {
    if (!state.data) return null;
    if (allDone(state.data)) return 'help';
    // 🔴 ВЫПУСКНИК НЕ ТЕРЯЕТ «СПРАВКУ», ОТКАЗАВШИСЬ ОТ ПОВТОРНОГО КРУГА (жалоба оунера 2026-08-25:
    // «отмена обучения решает проблему, но кнопка "Справка" заблокирована навсегда»). После «пройти
    // заново» `finished` снят, и отказ давал кнопку «Продолжить обучение» — единственную; дороги в
    // «Справку» (темы + перепройти акт) не оставалось вовсе. Первый круг уже пройден, если закрыт
    // акт `act2`: эта отметка рестартом НЕ сбрасывается.
    if (state.data.skipped) return graduated(state.data) ? 'help' : 'resume';
    // акт ждёт события (новый день / три победы): выпускнику показываем «Справку», новичку — «Обучение»
    if (state.data.gated) return state.data.finished ? 'help' : 'active';
    return 'active';
  },
  // Прогресс — ПО ТЕКУЩЕМУ АКТУ: общий счётчик «шаг 30 из 42» новичка только пугает.
  tutorialProgress: (state) => {
    if (!state.data) return null;
    // старый сервер не шлёт разбивку по актам — тогда считаем по общему счётчику, иначе подпись
    // на кнопке «Обучение» замирала на «шаг 1 из 41» и не менялась (фидбек оунера 2026-07-29)
    const perAct = state.data.act_total != null;
    return {
      n: perAct ? (state.data.act_index || 0) : (state.data.index || 0),
      total: perAct ? state.data.act_total : state.data.total,
      act: state.data.act,
    };
  },
  // Пройден ли акт (мягкий гейтинг разделов: «откроется после первой партии»).
  tutorialActDone: (state) => (act) => !state.data || (state.data.done || []).includes(act),
  // чек-лист «Путь новичка» (виджет в профиле): пункты, показывать ли, сколько наград к забору
  tutorialChecklist: (state) => (state.data && state.data.checklist) || [],
  tutorialChecklistOpen: (state) => !!(state.data && state.data.checklist_open),
  tutorialChecklistBadge: (state) => (state.data ? Number(state.data.checklist_ready) || 0 : 0),
  tutorialRoll: (state) => state.roll,
  // код пункта чек-листа, по которому игрок попросил помощь (экран раздела рисует подсказку)
  tutorialHelp: (state) => state.helpCode,
  // разовые обзоры разделов, которые сервер ещё не считает показанными (рынок при первом заходе)
  tutorialTours: (state) =>
    ((state.data && state.data.tours) || []).filter((code) => !state.toursSeen.includes(code)),
  // 🔴 ОСТАЛСЯ ЛИ ЗАХОД «ПРОЙТИ ОБУЧЕНИЕ ЗАНОВО» (решение оунера 2026-08-25: заново — только один
  // раз, иначе кнопка была бесплатным источником амуниции). Старый сервер поля не шлёт — считаем,
  // что заход есть: отказ придёт по кнопке и будет показан текстом.
  tutorialCanRestart: (state) => !state.data || state.data.can_restart !== false,
  // ЕДИНЫЙ гейт подсказок: открыто окно награды ИЛИ она вот-вот придёт (шаг уже отправлен).
  // Любая подсказка обучения обязана проверять ИМЕННО его — не `tutorialRoll`.
  tutorialBusy: (state) => !!state.roll || state.rollPending,
  // открыта ли сейчас подсказка ШАГА обучения (её не перекрываем ничем другим)
  tutorialSpotOpen: (state) => state.spotCount > 0,
};

const mutations = {
  SET_TUTORIAL: (state, data) => { state.data = data; state.notNow = []; },
  SET_TUT_ROUTE: (state, route) => { state.route = route; state.notNow = []; },
  // Экран сообщает: «этому шагу сейчас нечего показать» — берём следующий доступный шаг ЭТОГО экрана.
  // На сервер не идёт: шаг остаётся непройденным и всплывёт, когда условие появится.
  TUT_NOT_NOW: (state, code) => { if (code && !state.notNow.includes(code)) state.notNow.push(code); },
  // 🔴 ОТКЛАДЫВАНИЕ ОБРАТИМО (жалоба оунера 2026-09-01: «задание на каст короля не появилось даже
  // после того, как фигура вернулась из поединка раненой»). `TUT_NOT_NOW` держал код до нового
  // ответа `/tutorial` или смены роута, а экран партии не делает ни того, ни другого: игрок сидит
  // на `/play-web` всю партию, и шаг, отложенный на первой секунде («лечить некого, все целы»),
  // не всплывал НИКОГДА. Условие шага живёт на экране, поэтому и снимать отметку обязан экран.
  TUT_AGAIN: (state, code) => { state.notNow = state.notNow.filter((c) => c !== code); },
  SET_TUTORIAL_ROLL: (state, roll) => { state.roll = roll; },
  SET_TUTORIAL_PENDING: (state, v) => { state.rollPending = !!v; },
  SET_TUTORIAL_HELP: (state, code) => { state.helpCode = code || null; },
  SPOT_OPEN: (state) => { state.spotCount += 1; },
  SPOT_CLOSE: (state) => { state.spotCount = Math.max(0, state.spotCount - 1); },
  SET_TUTORIAL_LOADING: (state, v) => { state.loading = v; },
  // Смена игрока на устройстве: без сброса следующий увидел бы чужой прогресс обучения.
  // Обзор раздела закрыт игроком — гасим его СРАЗУ, не дожидаясь ответа сервера (см. `toursSeen`).
  TUT_TOUR_SEEN: (state, code) => { if (code && !state.toursSeen.includes(code)) state.toursSeen.push(code); },
  CLEAR_TUTORIAL: (state) => {
    state.data = null; state.loading = false; state.roll = null; state.rollPending = false;
    state.helpCode = null; state.spotCount = 0; state.notNow = []; state.toursSeen = [];
  },
};

const actions = {
  async fetchTutorial({ commit }) {
    commit('SET_TUTORIAL_LOADING', true);
    try {
      const r = await axios.get('/tutorial/');
      commit('SET_TUTORIAL', r.data);
      return r.data;
    } catch (e) {
      return null; // обучение — надстройка: молчим, игру это не ломает
    } finally {
      commit('SET_TUTORIAL_LOADING', false);
    }
  },
  // Шаг выполнен: сервер сам двигает указатель и решает, положена ли награда за акт.
  // 🔴 Аргумент может быть строкой (код) или `{ code, skipped }`: ПРОПУЩЕННЫЙ шаг (нечего
  // перезаряжать, пустой сундук) двигает указатель, но НЕ даёт ролл-награду — иначе награда
  // «приходит сама», без целевого действия (фидбек оунера 2026-07-30).
  async tutorialStepDone({ commit, state }, payload) {
    const code = typeof payload === 'string' ? payload : (payload && payload.code);
    const skipped = !!(payload && payload.skipped);
    if (!code) return null;
    // шаги Актов 3-4 идут уже ПОСЛЕ `finished` (первый круг), поэтому гейт — по `all_done`
    if (!state.data || allDone(state.data)) return null;
    commit('SET_TUTORIAL_PENDING', true); // подсказки молчат, пока не отыграет окно награды
    try {
      const r = await axios.post('/tutorial/step', { code, skipped });
      commit('SET_TUTORIAL', r.data);
      // награда за микро-шаг: сервер сам крутит рулетку и присылает выпавшее — показываем окном
      if (r.data && r.data.roll) {
        commit('SET_TUTORIAL_ROLL', { ...r.data.roll, granted: r.data.granted || [] });
      } else {
        commit('SET_TUTORIAL_PENDING', false); // награды нет — следующая подсказка сразу
      }
      return r.data;
    } catch (e) {
      commit('SET_TUTORIAL_PENDING', false);
      return null;
    }
  },
  // Забрать награду пункта «Пути новичка». Награду считает и выдаёт СЕРВЕР; возвращаем выданное,
  // чтобы экран показал окно добычи.
  async tutorialClaim({ commit }, code) {
    const r = await axios.post('/tutorial/checklist/claim', { code });
    commit('SET_TUTORIAL', r.data);
    return (r.data && r.data.granted) || [];
  },
  // Разовый обзор раздела просмотрен: сервер ставит метку (второй раз не покажет) и двигает
  // связанный пункт «Пути новичка». Это НЕ шаг обучения — указатель цепочки не трогается.
  async tutorialSeen({ commit }, code) {
    // 🔴 ЛОКАЛЬНАЯ ОТМЕТКА — ПЕРВЫМ ДЕЛОМ, ДО ЗАПРОСА (жалоба оунера 2026-08-30: «обучение в
    // магазине запускается три раза подряд»). Экран гасит обзор по `tutorialTours`, а тот менялся
    // только ответом сервера: пока запрос шёл, обзор успевал начаться заново с первой остановки, и
    // каждый круг слал ещё один `seen`. Та же отметка спасает от гонки с `GET /tutorial`: старый
    // ответ, выпущенный раньше, больше не воскрешает уже закрытый обзор.
    commit('TUT_TOUR_SEEN', code);
    try {
      const r = await axios.post('/tutorial/seen', { code });
      commit('SET_TUTORIAL', r.data);
      return r.data;
    } catch (e) {
      return null; // обучение — надстройка: молчим (обзор всё равно закрыт локально)
    }
  },
  // «покажи, как это сделать» по пункту чек-листа: экран раздела читает `tutorialHelp`
  tutorialHelp({ commit }, code) { commit('SET_TUTORIAL_HELP', code); },
  closeTutorialHelp({ commit }) { commit('SET_TUTORIAL_HELP', null); },
  closeTutorialRoll({ commit }) {
    commit('SET_TUTORIAL_ROLL', null);
    commit('SET_TUTORIAL_PENDING', false); // награда закрыта → можно показывать следующую подсказку
  },
  async tutorialSkip({ commit }) {
    const r = await axios.post('/tutorial/skip');
    commit('SET_TUTORIAL', r.data);
    return r.data;
  },
  // «Справка» → перепройти акт: сервер ставит указатель на его первый шаг, награды не дублируются
  async tutorialReplay({ commit }, act) {
    const r = await axios.post('/tutorial/replay', { act });
    commit('SET_TUTORIAL', r.data);
    return r.data;
  },
  async tutorialResume({ commit }) {
    const r = await axios.post('/tutorial/resume');
    commit('SET_TUTORIAL', r.data);
    return r.data;
  },
  // «Справка» → пройти ВСЁ обучение заново с первого шага (доступно и старым игрокам)
  async tutorialRestart({ commit }) {
    const r = await axios.post('/tutorial/restart');
    commit('SET_TUTORIAL', r.data);
    return r.data;
  },
};

export default { state, getters, mutations, actions };
